var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.5 23.8337C19.7132 23.8337 24.75 18.9834 24.75 13.0003C24.75 7.01724 19.7132 2.16699 13.5 2.16699C7.2868 2.16699 2.25 7.01724 2.25 13.0003C2.25 18.9834 7.2868 23.8337 13.5 23.8337Z",
    stroke: "black",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 10.292L10.6875 15.7087M10.6875 10.292L16.3125 15.7087",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWCloseIcon);
export default __webpack_public_path__ + "static/media/w-close-icon.b1921326ada7fd673b2245d6f22fcee6.svg";
export { ForwardRef as ReactComponent };